import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseAccountApiUrl, baseAccountPublicApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';
import { setUFOInteractionErrorCheck } from 'util/ufoUtils';

export const postToHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  data?: unknown,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.post(`${baseAccountApiUrl}${remainingPath}`, data, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postToHamsClientWithResponseHandlers = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  data?: unknown,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    const res = await hamsClient.post(`${baseAccountApiUrl}${remainingPath}`, data, {
      ...config,
      headers: {
        ...config.headers,
        ...impersonationHeader,
      },
      params,
    });

    if (res.status === 200 && res.data === '') {
      return 'Success';
    }
    return res.data;
  } catch (error: any) {
    if (
      error.response.status === 400 &&
      error.response.data.fieldErrors &&
      error.response.data.fieldErrors.serverId === 'Server Id is invalid'
    ) {
      return 'Server Id is invalid';
    }
    return Promise.reject(error);
  }
};

export const postFromHamsClientPublicAPI = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  data?: unknown,
  ufoName?: string,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.post(`${baseAccountPublicApiUrl}${remainingPath}`, data, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error: any) {
    setUFOInteractionErrorCheck(ufoName);
    return Promise.reject(error);
  }
};
